import { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

import { useSettings } from 'context/SettingsContext';
import 'media/css/lockScreen.scss';

const ACTIVITY_EVENTS: (keyof DocumentEventMap)[] = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];

export default function LockScreen() {
  const { settings, loading } = useSettings();
  const [isLocked, setIsLocked] = useState(false);
  const lockAfterSeconds = Math.max(Number(settings?.lockscreen_after_seconds) || 0, 0);

  useEffect(() => {
    if (loading || lockAfterSeconds <= 0 || isLocked) return undefined;

    let timer: ReturnType<typeof setTimeout>;
    const restartTimer = () => {
      clearTimeout(timer);
      timer = setTimeout(() => setIsLocked(true), lockAfterSeconds * 1000);
    };

    ACTIVITY_EVENTS.forEach((eventName) => document.addEventListener(eventName, restartTimer, { passive: true }));
    restartTimer();

    return () => {
      clearTimeout(timer);
      ACTIVITY_EVENTS.forEach((eventName) => document.removeEventListener(eventName, restartTimer));
    };
  }, [isLocked, loading, lockAfterSeconds]);

  useEffect(() => {
    if (!isLocked) return undefined;

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [isLocked]);

  if (!isLocked) return null;

  return (
    <div className="lock-screen" role="dialog" aria-modal="true" aria-labelledby="lock-screen-message">
      <div className="lock-screen__message">
        <div className="lock-screen__icon" aria-hidden="true">
          <a
            href="#current_window_reload_href"
            onClick={(e) => {
              e.preventDefault();
              window.location.reload();
            }}
            aria-label="Unlock screen"
          >
            <FontAwesomeIcon icon={faLock} />
          </a>
        </div>
        <p id="lock-screen-message">Màn hình đã khóa do không hoạt động trong thời gian dài</p>
      </div>
    </div>
  );
}

